// Module
var code = "<p>You can pay extra and provide us with instructions on how to allocate the extra funds.</p> ";
// Exports
export default code;